import { render, staticRenderFns } from "./GroupedLogDetails.vue?vue&type=template&id=028f1957&scoped=true&"
import script from "./GroupedLogDetails.vue?vue&type=script&lang=js&"
export * from "./GroupedLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f1957",
  null
  
)

export default component.exports